/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { connect } from 'react-redux';
import DataContainer from 'Util/Request/DataContainer';
import StoreLocator from './StoreLocator.component';
import PropTypes from 'prop-types';
import { StoreLocatorDispatcher } from '../../store/StoreLocator';
import { updateMeta } from 'Store/Meta/Meta.action';
export const BreadcrumbsDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Breadcrumbs/Breadcrumbs.dispatcher'
    );

const CmsBlocksAndSliderDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/CmsBlocksAndSlider/CmsBlocksAndSlider.dispatcher'
);

/** @namespace Route/StoreLocator/Container/mapStateToProps */
export const mapStateToProps = state => ({
    storeLocatorData : state.StoreLocatorReducer.storeLocatorData,
    google_map_api_key : state.ConfigReducer.google_map_api_key,
    store_locator_url : state.ConfigReducer.store_locator_url,
    map_markericon : state.ConfigReducer.map_markericon,
    map_selected_markericon : state.ConfigReducer.map_selected_markericon,
    map_zoom : state.ConfigReducer.map_zoom,
    device: state.ConfigReducer.device,
    blocks: state.CmsBlocksAndSliderReducer.blocks?.items
});

/** @namespace Route/StoreLocator/Container/mapDispatchToProps */
export const mapDispatchToProps = dispatch => ({
    updateBreadcrumbs: (breadcrumbs) => {
        BreadcrumbsDispatcher.then(
            ({ default: dispatcher }) => dispatcher.update(breadcrumbs, dispatch)
        );
    },
    getStoreLocatorData : () => StoreLocatorDispatcher.handleData(dispatch),
    updateMeta: (meta) => dispatch(updateMeta(meta)),
    requestCmsBlocks: (options) => CmsBlocksAndSliderDispatcher.then(({default: dispatcher}) => dispatcher.handleData(dispatch, options))
});

/** @namespace Route/StoreLocator/Container */
export class StoreLocatorContainer extends DataContainer {
    static propTypes = {
        updateBreadcrumbs: PropTypes.func.isRequired,
        updateMeta: PropTypes.func.isRequired,
        storeLocatorData : PropTypes.object,
        google_map_api_key : PropTypes.string
    };

    static defaultProps = {
        storeLocatorData: {}
    };

    state = {
        stateKey : null
    }


    componentDidMount() {
        const {
            updateMeta,
            storeLocatorData,
            getStoreLocatorData,
            title,
            meta_title,
            meta_keywords,
            meta_description,
            redirect_code_previous
        } = this.props;

        updateMeta({
            title: title,
            meta_title: meta_title,
            meta_description: meta_description,
            meta_keywords: meta_keywords,
            canonical_url : window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous
        });
        scroll({
            top: 0,
            behavior: "smooth"
        });
        if (storeLocatorData.constructor === Object) {
            getStoreLocatorData();
        }
        if(!this.state.stateKey){
            this.setState({stateKey : Math.random()});
        }
        this.getMenuAndCmsBlock();

        this._updateBreadcrumbs();
    }

    getMenuAndCmsBlock() {
        const { requestCmsBlocks } = this.props;

        const options = {
            identifiers: [
                'storelocator_bottom_block',
                'storelocator_top_block'
            ]
        }

        requestCmsBlocks(options);
    }

    _updateBreadcrumbs() {
        const { updateBreadcrumbs, store_locator_url } = this.props;
        const breadcrumbs = [
            {
                url: `/${store_locator_url}`,
                name: __('Store Locator')
            }
        ];connect

        updateBreadcrumbs(breadcrumbs);
    }

    render() {
        return (
            <StoreLocator
              { ...this.props }
              { ...this.state }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreLocatorContainer);
